"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeCSVMapper = exports.DefaultKeyMappings = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var index_1 = require("../../index");
var location_field_1 = require("../fields/location.field");
var nested_list_field_1 = require("../fields/nested.list.field");
var MappingFunctions = (_a = {},
    // [IkeFieldType.NUMBER]: (field: CollectionModelFieldNumber, val: string) => field.Mutator.manual(val),
    _a[core_api_1.IkeFieldType.TEXT] = function (field, val) {
        if (val == null || val === '') {
            return true;
        }
        field.Mutator.manual(String(val));
        return true;
    },
    _a[core_api_1.IkeFieldType.SELECT_LIST] = function (field, valIn) {
        if (valIn == null || valIn === '') {
            return true;
        }
        var val = String(valIn);
        field.Mutator.manual(val);
        var hasValue = field.hasValue();
        if (hasValue) {
            return true;
        }
        // Attempt to match based on the schema options
        var textMatch = field.schema.options.find(function (opt) { return opt.text.toLowerCase() === val.toLowerCase(); });
        if (textMatch) {
            field.Mutator.manual(textMatch.value);
        }
        return field.hasValue();
    },
    _a[core_api_1.IkeFieldType.NESTED_LIST] = function (field, val) {
        if (val == null || val === '') {
            return true;
        }
        field.Mutator.manual(nested_list_field_1.CollectionModelFieldNestedList.parse(val));
        return field.hasValue();
    },
    _a[core_api_1.IkeFieldType.LOCATION] = function (field, val, key) {
        var oldValue = Object.assign({}, field.value);
        var value = parseFloat(val);
        if (isNaN(value) || isNaN(val)) {
            return false;
        }
        switch (key) {
            case 'lat':
                oldValue.latitude = parseFloat(val);
                field.Mutator.manual(oldValue);
                return field.value.latitude === oldValue.latitude;
            case 'lng':
                oldValue.longitude = parseFloat(val);
                field.Mutator.manual(oldValue);
                return field.value.longitude === oldValue.longitude;
            default:
                throw new Error('Invalid location key: "' + key + '\'');
        }
    },
    _a);
/**
 * Lower cased alias's for the keys in the mapping process.
 */
exports.DefaultKeyMappings = {
    lat: ['lat', 'latitude'],
    lng: ['lng', 'longitude', 'long']
};
var IkeCSVMapper = /** @class */ (function () {
    function IkeCSVMapper(csv, form) {
        var e_1, _a;
        this.csv = null;
        this.form = null;
        /** List of fields that can be mapped to */
        this.mappings = [];
        /** List of the collections that have been created by these mappings */
        this.processed = [];
        this.csv = csv;
        this.form = form;
        try {
            for (var _b = tslib_1.__values(this.form.fields), _c = _b.next(); !_c.done; _c = _b.next()) {
                var field = _c.value;
                if (field.type === 'location') {
                    this.mappings.push({ field: field, fieldKey: 'lat', csvIndex: -1, isValid: true });
                    this.mappings.push({ field: field, fieldKey: 'lng', csvIndex: -1, isValid: true });
                }
                else if (MappingFunctions[field.type]) {
                    this.mappings.push({ field: field, csvIndex: -1, isValid: true });
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    IkeCSVMapper.prototype.toJSON = function () {
        var e_2, _a;
        var output = [];
        try {
            for (var _b = tslib_1.__values(this.mappings), _c = _b.next(); !_c.done; _c = _b.next()) {
                var mapping = _c.value;
                if (mapping.csvIndex === -1) {
                    continue;
                }
                output.push({
                    fieldId: mapping.field.id,
                    fieldKey: mapping.fieldKey,
                    csvHeader: this.csv.headers[mapping.csvIndex]
                });
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return output;
    };
    IkeCSVMapper.prototype.getMapping = function (fieldId, fieldKey) {
        var e_3, _a;
        try {
            for (var _b = tslib_1.__values(this.mappings), _c = _b.next(); !_c.done; _c = _b.next()) {
                var mapping = _c.value;
                if (mapping.field.id !== fieldId) {
                    continue;
                }
                if (fieldKey == null || fieldKey === mapping.fieldKey) {
                    return mapping;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return null;
    };
    IkeCSVMapper.prototype.setMapping = function (mapping, csvHeaderIndex, shouldProcess) {
        if (shouldProcess === void 0) { shouldProcess = true; }
        if (csvHeaderIndex == null || isNaN(csvHeaderIndex) || csvHeaderIndex < 0) {
            mapping.csvIndex = -1;
        }
        else {
            mapping.csvIndex = csvHeaderIndex;
        }
        if (shouldProcess) {
            this.processRows();
        }
    };
    IkeCSVMapper.prototype.getCollectionValue = function (mapping, index) {
        var collection = this.processed[index];
        var raw = this.csv.rows[index];
        var rawValue = raw[mapping.csvIndex];
        var field = collection.getField(mapping.field.id);
        if (location_field_1.CollectionModelFieldLocation.isLocationField(field)) {
            var value = 0;
            switch (mapping.fieldKey) {
                case 'lat':
                    value = field.value.latitude;
                    break;
                case 'lng':
                    value = field.value.longitude;
                    break;
                default: throw new Error('Invalid mapping key');
            }
            return { value: String(value), isValid: value !== 0, raw: rawValue };
        }
        var hasRawValue = rawValue != null && rawValue !== '';
        if (hasRawValue) {
            return { value: field.displayValue, isValid: field.hasValue(), raw: rawValue };
        }
        else {
            return { value: field.displayValue, isValid: true, raw: rawValue };
        }
    };
    IkeCSVMapper.prototype.reset = function () {
        var e_4, _a;
        try {
            for (var _b = tslib_1.__values(this.mappings), _c = _b.next(); !_c.done; _c = _b.next()) {
                var mapping = _c.value;
                mapping.csvIndex = -1;
                mapping.isValid = true;
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    /**
     * Attempt to guess some default mappings based off the headers in the CSV and the fields in the form
     */
    IkeCSVMapper.prototype.setDefaultMappings = function () {
        var e_5, _a, e_6, _b;
        var _this = this;
        var headerSearch = {};
        for (var i = 0; i < this.csv.headers.length; i++) {
            var header = this.csv.headers[i];
            headerSearch[header.toLowerCase()] = i;
        }
        var hasMapped = false;
        var applyMapping = function (key, mapping) {
            if (mapping.csvIndex > -1) {
                return true;
            }
            var index = headerSearch[key];
            if (index != null) {
                delete headerSearch[key];
                _this.setMapping(mapping, index, false);
                hasMapped = true;
                return true;
            }
            return false;
        };
        try {
            for (var _c = tslib_1.__values(this.mappings), _d = _c.next(); !_d.done; _d = _c.next()) {
                var mapping = _d.value;
                var field = mapping.field, fieldKey = mapping.fieldKey;
                // Is there a direct match between header name and field name
                if (applyMapping(field.displayName.toLowerCase(), mapping)) {
                    continue;
                }
                // See if any other keys will map
                var searchKeys = exports.DefaultKeyMappings[fieldKey];
                if (searchKeys == null) {
                    continue;
                }
                try {
                    for (var searchKeys_1 = (e_6 = void 0, tslib_1.__values(searchKeys)), searchKeys_1_1 = searchKeys_1.next(); !searchKeys_1_1.done; searchKeys_1_1 = searchKeys_1.next()) {
                        var search = searchKeys_1_1.value;
                        if (applyMapping(search, mapping)) {
                            break;
                        }
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (searchKeys_1_1 && !searchKeys_1_1.done && (_b = searchKeys_1.return)) _b.call(searchKeys_1);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_5) throw e_5.error; }
        }
        if (hasMapped) {
            this.processRows();
        }
    };
    Object.defineProperty(IkeCSVMapper.prototype, "isValid", {
        get: function () {
            var e_7, _a;
            if (this.csv.rows.length === 0) {
                return false;
            }
            var hasMappings = false;
            try {
                for (var _b = tslib_1.__values(this.mappings), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var field = _c.value;
                    if (field.csvIndex > -1) {
                        hasMappings = true;
                    }
                    if (field.isValid === false) {
                        return false;
                    }
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_7) throw e_7.error; }
            }
            return hasMappings;
        },
        enumerable: false,
        configurable: true
    });
    IkeCSVMapper.prototype.processRows = function () {
        var e_8, _a, e_9, _b;
        this.processed = [];
        try {
            for (var _c = tslib_1.__values(this.mappings), _d = _c.next(); !_d.done; _d = _c.next()) {
                var field = _d.value;
                field.isValid = true;
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_8) throw e_8.error; }
        }
        try {
            for (var _e = tslib_1.__values(this.csv.rows), _f = _e.next(); !_f.done; _f = _e.next()) {
                var row = _f.value;
                this.processed.push(this.processRow(row));
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_9) throw e_9.error; }
        }
    };
    IkeCSVMapper.prototype.processRow = function (row) {
        var e_10, _a;
        var collection = index_1.IkeModel.Collection.create(this.form, null); // TODO do we always need a loader?
        try {
            for (var _b = tslib_1.__values(this.mappings), _c = _b.next(); !_c.done; _c = _b.next()) {
                var mapping = _c.value;
                if (mapping.csvIndex === -1) {
                    continue;
                }
                var field = collection.getField(mapping.field.id);
                var Mapper = MappingFunctions[mapping.field.type];
                var isValid = Mapper(field, row[mapping.csvIndex], mapping.fieldKey);
                if (isValid === false) {
                    mapping.isValid = false;
                }
            }
        }
        catch (e_10_1) { e_10 = { error: e_10_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_10) throw e_10.error; }
        }
        return collection;
    };
    return IkeCSVMapper;
}());
exports.IkeCSVMapper = IkeCSVMapper;
//# sourceMappingURL=csv.mapper.js.map